import React, { useEffect, useContext } from 'react'
import { addYears } from 'date-fns'

import * as location from '~/constants/location'
import Select from '~/components/Select'
import Textarea from '~/components/Textarea'
import PhoneInput from '~/components/PhoneInput'
import Field from './Field'
import WebsiteField from '../../BulkEdit/EditInformations/WebsiteField'
import PrimaryAdditionalPhoneField from '../../BulkEdit/EditInformations/PrimaryAdditionalPhoneField'
import LabelInput from '../../BulkEdit/EditInformations/LabelInput'
import { Container, Form } from '../../BulkEdit/EditInformations/styles'
import PrimaryAdditionalCategories from '../../BulkEdit/EditInformations/PrimaryAdditionalCategories'
import AddressField from './AddressField'

import { EditedFields } from '../index'
import DateTimePicker from '~/components/DateTimePicker'

const EditLocationForm = ({
  formik,
  removeLabels,
  onChangeRemoveLabels,
  addedCategories = false,
  locationCategories,
}) => {
  const {
    editedFields: { location: editedFields },
    setEditedFields,
  } = useContext(EditedFields)

  const handleSwitchChange = switchId => {
    setEditedFields(prevState => ({
      ...prevState,
      location: {
        ...prevState.location,
        [switchId]: !editedFields[switchId],
      },
    }))
  }

  const defaultProps = {
    onSwitchChange: handleSwitchChange,
    editableFields: editedFields,
    controller: formik,
  }

  useEffect(() => {
    setEditedFields(prevState => ({
      ...prevState,
      location: {
        ...prevState.location,
        'categories.primaryCategorySwitch': addedCategories,
      },
    }))
  }, [addedCategories, setEditedFields])

  return (
    <Container>
      <Form>
        <Field {...defaultProps} name="storeCode" label="Location Code" />
        <Field
          {...defaultProps}
          name="title"
          label="Location name"
          enableVariables
        />
        <Field
          {...defaultProps}
          name="openInfo.status"
          label="Location status"
          options={location.openInfoStatusOptions}
          placeholder=""
          type="select"
          render={props => (
            <Select
              {...props}
              isDisabled={props.disabled}
              menuPortalTarget={document.querySelector('body')}
            />
          )}
        />
        <Field
          {...defaultProps}
          name="openInfo.openingDate"
          label="Opening Date"
          type="date"
          render={props => (
            <DateTimePicker
              {...props}
              width="100%"
              maxWidth={9999}
              showIcon
              style={{ width: '20em' }}
              dateFormat="d-m-Y"
              value={formik?.values?.openInfo?.openingDate || ''}
              options={{
                mode: 'single',
                maxDate: addYears(new Date(), 1),
              }}
            />
          )}
        />
        <PrimaryAdditionalCategories
          {...defaultProps}
          label="Categories"
          options={locationCategories}
        />
        <AddressField {...defaultProps} label="Address" />
        <WebsiteField
          {...defaultProps}
          name="websiteUri"
          label="Website"
          initialUrl={formik?.values?.websiteUri}
        />
        <PrimaryAdditionalPhoneField {...defaultProps} label="Phone number" />
        <Field
          {...defaultProps}
          name="adWordsLocationExtensions.adPhone"
          label="Google Ads number"
          render={PhoneInput}
          className="form-control"
          onChange={v =>
            formik.setFieldValue('adWordsLocationExtensions.adPhone', v)
          }
        />
        <Field
          {...defaultProps}
          name="labels"
          label="Labels"
          removeLabels={removeLabels}
          onChangeRemoveLabels={onChangeRemoveLabels}
          render={LabelInput}
          valueExtractor={v => v}
        />
        <Field
          {...defaultProps}
          name="profile.description"
          label="Location Description"
          onChange={(e, { setValue }) => setValue(e?.target?.value)}
          render={Textarea}
          maxLength={750}
          enableVariables
        />
      </Form>
    </Container>
  )
}

export default EditLocationForm
